/**
 * /admin/edd/$id — PEP EDD case detail (route shell).
 * Screen impl in `./edd.$id-screen.tsx`, lazy-loaded.
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/edd/$id')({
  component: lazyRouteComponent(
    () => import('./edd.$id-screen'),
    'AdminEddDetail',
  ),
});
